// React Utils
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

// Redux Thunks
import { getPublicEventosInfo, loadMorePublicEventos } from "@/features/publicEventos/publicEventosThunks";
import { createNotificacion } from "@/features/notificacion/notificacionThunks";

// Components
import CategoryBar from "@/components/CategoryBar";
import TicketCarousel from "@/components/TicketCarousel/TicketCarousel";
import InfiniteCarousel from "@/components/InfiniteCarousel";
import CitiesCarousel from "@/components/CarteleraCitiesCarousel/CitiesCarousel";
import InfiniteCarouselInhouseAds from "@/components/InfiniteCarouselInhouseAds";
import TicketCard from "@/components/TicketCarousel/TicketCard";

// Skeleton
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// Eliminar Al integrar con backend
import EventImage1 from "@/assets/eventos/ViejasDeMierda.webp";
import EventImage2 from "@/assets/eventos/ClubAmandaDJCeleArrabal.webp";
import EventImage3 from "@/assets/eventos/ClubAmandaFullBailableYElectronic.webp";
import EventImage4 from "@/assets/eventos/CelebrarEnAlonso.webp";
import EventImage5 from "@/assets/eventos/Ferxxo.webp";
import EventImage6 from "@/assets/eventos/JorisVoorn.webp";

import videoEyesAppwhoop from "@/assets/eventos/video/eyesAppWhoop.mp4";
import City1 from "@/assets/cities/Andes.webp";
import City2 from "@/assets/cities/Castro.webp";
import City3 from "@/assets/cities/CiudadDeConcepcion.webp";
import City4 from "@/assets/cities/IslaDePascua.webp";
import City5 from "@/assets/cities/SantiagoDeChile.webp";
import City6 from "@/assets/cities/Valdivia.webp";
import City7 from "@/assets/cities/VillaDelMar.webp";
import BackAppwhoop from "@/assets/background.webp";
import Ambassador1 from "@/assets/recentAmbassador/mujer1.webp";
import Ambassador2 from "@/assets/recentAmbassador/mujer2.webp";
import Ambassador3 from "@/assets/recentAmbassador/mujer3.webp";
import Ambassador4 from "@/assets/recentAmbassador/mujer4.webp";
import Ambassador5 from "@/assets/recentAmbassador/mujer5.webp";
import Ambassador6 from "@/assets/recentAmbassador/duo.webp";
import Ambassador7 from "@/assets/recentAmbassador/chris.webp";

// Assests publicidad carousel
import mktCorpbckg from "@/assets/bckg-publicidad-corporativa.webp";

// importar constante con el listado de categorías válidas
import { CATEGORIAS_EVENTO } from "@/constants/categoriasEvento";

export default function Home() {
  const dispatch = useDispatch();
  
  // Redux state
  const { user } = useSelector((state) => state.auth);
  
  // Estados locales para el manejo de la carga
  const [isLoading, setIsLoading] = useState(true);
  const [dataLoadComplete, setDataLoadComplete] = useState(false);

  // Redux state
  const { 
    infoPublicEventos, 
    isLoadingPublicEventos, 
    failurePublicEventos,
    hasNextPage,
    currentPage,
    currentFilters
  } = useSelector((state) => state.publicEventos);

  // console.log("Eventos públicos desde Redux:", infoPublicEventos);
  
  // Función para cargar más eventos (paginación)
  const handleLoadMore = async () => {
    if (!hasNextPage || isLoadingPublicEventos) return;
    
    const now = new Date().toISOString();
    const farPast = '1970-01-01T00:00:00.000Z';
    const nextPage = currentPage + 1;
    await dispatch(loadMorePublicEventos({ 
      ...currentFilters,
      page: nextPage,
      limit: 10,
      fechaHoraInicioDesde: farPast,  // Disable default filter to allow started events
      fechaHoraFinDesde: now          // Only show events that haven't ended
    }));
  };
  
  // Cargar eventos al montar el componente
  useEffect(() => {
    const loadData = async () => {
      setIsLoading(true);
      try {
        const now = new Date().toISOString();
        const farPast = '1970-01-01T00:00:00.000Z';
        await dispatch(getPublicEventosInfo({ 
          page: 1, 
          limit: 10,
          fechaHoraInicioDesde: farPast,  // Disable default filter to allow started events
          fechaHoraFinDesde: now          // Only show events that haven't ended
        }));
        setDataLoadComplete(true);
      } catch (error) {
        console.error("Error loading events data:", error);
        setDataLoadComplete(true);
      }
    };

    loadData();
  }, [dispatch]);

  // Verificar si todas las cargas de Redux han terminado
  useEffect(() => {
    if (dataLoadComplete && !isLoadingPublicEventos) {
      // Pequeño delay para asegurar que la pantalla de carga se vea
      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [dataLoadComplete, isLoadingPublicEventos]);

  // Si hay errores, mostrar la pantalla de carga por un tiempo mínimo
  useEffect(() => {
    if (failurePublicEventos) {
      const errorTimer = setTimeout(() => {
        setIsLoading(false);
      }, 2000);

      return () => clearTimeout(errorTimer);
    }
  }, [failurePublicEventos]);

  const isLoadingVerify = isLoading || isLoadingPublicEventos || !dataLoadComplete;

  // Placeholder for categories, replace with actual data
  let categories = ["Todos los Tickets"]
  categories = categories.concat(CATEGORIAS_EVENTO);
  console.log("Categories for CategoryBar:", categories);

  const categoryBarProps = { categories };

  // Example items for the advertising carousel
  const advertisingItems = [
    {
      id: 1,
      name: "Los mejores Panoramas y Datos se disfrutan en AppWhoop Ticket",
      verified: true,
      location: "Registrate gratis ahora",
      categories: [""],
      onFollow: () => {},
      onShowTickets: () => {},
      // mediaSrc: videoEyesAppwhoop,
      mediaType: "video",
      backgroundSrc: mktCorpbckg,
    },
    {
      id: 2,
      name: "Ferxxo",
      verified: true,
      location: "Estadio Monumental, Macul",
      categories: ["Concierto", "Música"],
      onFollow: () => {},
      onShowTickets: () => {},
      mediaSrc: EventImage5,
      mediaType: "image",
      backgroundSrc: EventImage5,
    },
    {
      id: 3,
      name: "Viejas de Mierda",
      verified: true,
      location: "Espacio Riesco, Huechuraba",
      categories: ["Teatro", "Comedia"],
      onFollow: () => {},
      onShowTickets: () => {},
      mediaSrc: EventImage1,
      mediaType: "image",
      backgroundSrc: EventImage1,
    },
    {
      id: 4,
      name: "Club Amanda Full Bailable y Electronic",
      verified: true,
      location: "Embajador Doussinague, Vitacura",
      categories: ["Discoteca", "Bailable"],
      onFollow: () => {},
      onShowTickets: () => {},
      mediaSrc: EventImage3,
      mediaType: "image",
      backgroundSrc: EventImage3,
    },
    {
      id: 5,
      name: "Celebrar en Alonso",
      verified: true,
      location: "Alonso de Córdova, Vitacura",
      categories: ["Restobar", "Celebración"],
      onFollow: () => {},
      onShowTickets: () => {},
      mediaSrc: EventImage4,
      mediaType: "image",
      backgroundSrc: EventImage4,
    },
  ];
  const inhouseAdvertisingItems = [
    {
      id: 1,
      title: "Únete gratis al Club de AppWhoop Ticket",
      verified: true,
      subTitle: "Y comienza a ganar 💰 como Embajador - Empresa - Artista",
      subTitleXs: "Y comienza a ganar 💰",
      recentAmbassadors: [
        { name: "Artista 1", image: Ambassador1 },
        { name: "Artista 2", image: Ambassador2 },
        { name: "Artista 3", image: Ambassador3 },
        { name: "Artista 4", image: Ambassador4 },
        { name: "Artista 7", image: Ambassador7 },
      ],
      adsRenderComponent: "CarouselItemFirstAdd",
      onFollow: () => {},
      onShowTickets: () => {},
      mediaSrc: null,
      mediaType: null,
      backgroundSrc: BackAppwhoop,
    },
    // {
    //   id: 2,
    //   title: "Ferxxo",
    //   verified: false,
    //   subTitle: "Estadio Monumental, Macul",
    //   adsRenderComponent: "CarouselItemGeneralAdd",
    //   onFollow: () => {},
    //   onShowTickets: () => {},
    //   mediaSrc: EventImage5,
    //   mediaType: "image",
    //   backgroundSrc: EventImage5,
    // },
  ];

  // Datos de ejemplo para cartelera por ciudad
  const cities = [
    { id: 1, like: true, location: "Santiago De Chile", image: City5 },
    { id: 2, like: false, location: "Andes", image: City1 },
    { id: 3, like: false, location: "Castro", image: City2 },
    { id: 4, like: false, location: "Ciudad De Concepcion", image: City3 },
    { id: 5, like: true, location: "Isla De Pascua", image: City4 },
    { id: 6, like: false, location: "Santiago De Chile", image: City5 },
    { id: 7, like: false, location: "Valdivia", image: City6 },
    { id: 8, like: true, location: "Viña Del Mar", image: City7 },
    { id: 9, like: false, location: "Andes 2", image: City1 },
    { id: 10, like: false, location: "Castro 2", image: City2 },
    { id: 11, like: false, location: "Ciudad De Concepcion 2", image: City3 },
    { id: 12, like: true, location: "Isla De Pascua 2", image: City4 },
    { id: 13, like: false, location: "Santiago De Chile 2", image: City5 },
    { id: 14, like: false, location: "Valdivia 2", image: City6 },
    { id: 15, like: false, location: "Viña Del Mar 2", image: City7 },
  ];

  // Función temporal para probar crear notificaciones
  const handleTestNotification = async () => {
    if (!user?.uid) {
      alert('Debes estar autenticado para crear notificaciones');
      return;
    }

    try {
      await dispatch(createNotificacion({
        urlDestino: `/perfil/${user.uid}`,
        type: 'any',
        emisor: 'Sistema de Prueba',
        contenido: `Esta es una notificación de prueba creada el ${new Date().toLocaleString()}`,
        userUids: [user.uid, "226a4a73-57a5-428c-a61a-866d69987b4a"]
      })).unwrap();
      alert('¡Notificación creada exitosamente! Revisa el ícono de campana.');
    } catch (error) {
      alert(`Error al crear notificación: ${error.message || error}`);
    }
  };

  return (
    <div className="flex flex-col w-full min-h-screen bg-aw-bgbluedark-30 text-white">      
      {/* Advertising Carousel */}
      {/* <InfiniteCarousel slides={advertisingItems} /> */}
      <InfiniteCarouselInhouseAds slides={inhouseAdvertisingItems} />
      {/* Tickets */}
      <div>
        {/* Categorias */}
        <CategoryBar {...categoryBarProps} />
        {/* Tickets Destacados del momento */}
        <h3 className="text-xl font-semibold mb-3">Tickets destacados</h3>
        
        {isLoadingVerify ? (
          <SkeletonTheme baseColor="#1e293b" highlightColor="#334155">
            <div className="flex gap-4 overflow-x-auto scrollbar-hide px-2 py-4 bg-aw-bluedark-75 rounded-lg">
              {[1, 2, 3, 4, 5].map((index) => (
                <div key={index} className="min-w-[200px] max-w-[200px] bg-aw-bgbluedark-30">
                  <Skeleton height={208} className="mb-2" borderRadius={8} />
                  <div className="px-2 py-1">
                    <Skeleton height={20} className="mb-1" />
                    <Skeleton height={14} />
                  </div>
                  <Skeleton height={36} className="mt-2" />
                </div>
              ))}
            </div>
          </SkeletonTheme>
        ) : failurePublicEventos ? (
          <div className="flex justify-center items-center h-32">
            <p className="text-red-400">
              Error al cargar eventos. Intenta recargar la página.
            </p>
          </div>
        ) : infoPublicEventos && infoPublicEventos.length > 0 ? (
          <TicketCarousel 
            tickets={infoPublicEventos} 
            TicketItem={TicketCard}
            hasMore={hasNextPage}
            isLoadingMore={isLoadingPublicEventos}
            onLoadMore={handleLoadMore}
          />
        ) : (
          <div className="flex justify-center items-center h-32">
            <p className="text-gray-400 text-lg">
              Aún no hay eventos para esta sección
            </p>
          </div>
        )}
        {/* Tickets de esta semana */}
        {/* <h3 className="text-xl font-semibold mb-3">
          Tickets de esta semana
        </h3>
        <TicketCarousel tickets={tickets} TicketItem={TicketCard} /> */}
        {/* Ticket del mes */}
        {/* <h3 className="text-xl font-semibold mb-3">Ticket del mes</h3>
        <TicketCarousel tickets={tickets} TicketItem={TicketCard} /> */}
        {/* Cartelera por ciudad */}
        {/* <h3 className="text-xl font-semibold mb-3">
          Cartelera por ciudad
        </h3>
        <CitiesCarousel cities={cities} /> */}
        {/* Ticket FREE PASS */}
        {/* <h3 className="text-xl font-semibold mb-3">Ticket FREE PASS</h3>
        <TicketCarousel tickets={tickets} TicketItem={TicketCard} /> */}
        {/* Inhouse Advertising */}
        {/* <InfiniteCarouselInhouseAds slides={inhouseAdvertisingItems} /> */}
      </div>
    </div>
  );
}
